import ApiClient from './ApiClient';

class WaCampaignsAPI extends ApiClient {
  constructor() {
    super('whatsapp_campaigns', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  show(campaignId) {
    return axios.get(`${this.url}/${campaignId}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(campaignId, data) {
    return axios.patch(`${this.url}/${campaignId}`, data);
  }

  delete(campaignId) {
    return axios.delete(`${this.url}/${campaignId}`);
  }

  pause(campaignId) {
    return axios.post(`${this.url}/${campaignId}/pause`);
  }

  resume(campaignId) {
    return axios.post(`${this.url}/${campaignId}/resume`);
  }

  preview(campaignId, contactId = null) {
    const params = contactId ? { contact_id: contactId } : {};
    return axios.post(`${this.url}/${campaignId}/preview`, params);
  }

  getStats() {
    return axios.get(`${this.url}/stats`);
  }

  getLogs(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/logs`, { params });
  }
}

export default new WaCampaignsAPI();
